import { DEFAULT_LOCALE, i18n } from './index'

/**
 * Overlays the live translation bundle on top of the build-time snapshot.
 *
 * The bundle is published from backend/i18n to the assets CDN on a 300s TTL so
 * copy can change without a frontend deploy — the case that matters is the
 * backend keying new plan copy, which without this would render as raw dotted
 * paths until the next frontend release.
 *
 * Fire-and-forget by design: nothing awaits it and every failure is swallowed,
 * because the snapshot is already a complete, correct bundle. The worst outcome
 * is being exactly as fresh as a bundle-only build.
 *
 * Callers must resolve inside a `computed` for the overlay to take effect —
 * vue-i18n messages are reactive, but a value resolved once during `setup` is
 * not.
 */
export const refreshServerMessages = async (): Promise<void> => {
  const base = import.meta.env.VITE_ASSETS_URL

  if (!base) return

  try {
    const response = await fetch(`${base}/translations/${DEFAULT_LOCALE}.json`)

    if (!response.ok) return

    const bundle = await response.json()

    if (!bundle || typeof bundle !== 'object' || Array.isArray(bundle)) return

    i18n.global.mergeLocaleMessage(DEFAULT_LOCALE, bundle)
  } catch {
    // Snapshot stands.
  }
}
